import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const LockUnlockedIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M8.83486 10.6668C8.83473 11.1279 8.46124 11.5014 8.00021 11.5015C7.53906 11.5015 7.16498 11.128 7.16486 10.6668C7.16486 10.2056 7.53898 9.8315 8.00021 9.8315C8.46132 9.83162 8.83486 10.2057 8.83486 10.6668Z"
      fill="currentColor"
    />
    <path
      d="M13.5 7.99968C13.4998 7.5397 13.127 7.16685 12.667 7.16667H3.33301C2.87303 7.16685 2.50018 7.5397 2.5 7.99968V13.3337C2.50018 13.7936 2.87303 14.1665 3.33301 14.1667H12.667C13.127 14.1665 13.4998 13.7936 13.5 13.3337V7.99968ZM14.5 13.3337C14.4998 14.3459 13.6793 15.1665 12.667 15.1667H3.33301C2.32074 15.1665 1.50018 14.3459 1.5 13.3337V7.99968C1.50018 6.98742 2.32074 6.16685 3.33301 6.16667H12.667C13.6793 6.16685 14.4998 6.98742 14.5 7.99968V13.3337Z"
      fill="currentColor"
    />
    <path
      d="M4.16666 6.66649V4.66649C4.16673 3.82285 4.44513 3.00282 4.95865 2.33348C5.47226 1.66416 6.19258 1.18279 7.00748 0.964343C7.82245 0.745967 8.68693 0.802672 9.46646 1.12548C10.246 1.44834 10.898 2.01886 11.32 2.7495C11.4581 2.98864 11.3755 3.29501 11.1364 3.43309C10.8974 3.57089 10.5919 3.48923 10.4538 3.25048C10.142 2.71049 9.66065 2.288 9.08463 2.0493C8.5084 1.81064 7.8687 1.76874 7.26627 1.93016C6.66409 2.09161 6.13219 2.44732 5.75259 2.94188C5.37295 3.43663 5.16673 4.04287 5.16666 4.66649V6.66649C5.16666 6.94263 4.9428 7.16649 4.66666 7.16649C4.39051 7.16649 4.16666 6.94263 4.16666 6.66649Z"
      fill="currentColor"
    />
  </svg>
);
